var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
      },
    },
    [
      _c("defs", [
        _c(
          "filter",
          {
            attrs: {
              id: "filter-1",
              x: "-1.7%",
              y: "-12.5%",
              width: "103.3%",
              height: "135.0%",
              filterUnits: "objectBoundingBox",
            },
          },
          [
            _c("feOffset", {
              attrs: {
                dx: "0",
                dy: "1",
                in: "SourceAlpha",
                result: "shadowOffsetOuter1",
              },
            }),
            _vm._v(" "),
            _c("feGaussianBlur", {
              attrs: {
                stdDeviation: "1",
                in: "shadowOffsetOuter1",
                result: "shadowBlurOuter1",
              },
            }),
            _vm._v(" "),
            _c("feColorMatrix", {
              attrs: {
                values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
                type: "matrix",
                in: "shadowBlurOuter1",
                result: "shadowMatrixOuter1",
              },
            }),
            _vm._v(" "),
            _c(
              "feMerge",
              [
                _c("feMergeNode", { attrs: { in: "shadowMatrixOuter1" } }),
                _vm._v(" "),
                _c("feMergeNode", { attrs: { in: "SourceGraphic" } }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            fill: "none",
            "fill-rule": "evenodd",
            filter: _vm.shadow ? "url(#filter-1)" : "",
          },
        },
        [
          _c("path", { attrs: { d: "M0 0h19.2v19.2H0z" } }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: _vm.color,
              d: "M9.8 4c-4 0-7.416 2.488-8.8 6 1.384 3.512 4.8 6 8.8 6 4 0 7.416-2.488\n      8.8-6-1.384-3.512-4.8-6-8.8-6zm0 10c-2.208 0-4-1.792-4-4s1.792-4 4-4 4 1.792 4 4-1.792 4-4\n      4zm0-6.4A2.397 2.397 0 0 0 7.4 10c0 1.328 1.072 2.4 2.4 2.4 1.328 0 2.4-1.072 2.4-2.4\n      0-1.328-1.072-2.4-2.4-2.4z",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }